import { ReactElement } from 'react';
import { JobSubTrainingJobsContainer } from '../../../../modules/jobs/containers/details/JobSubTrainingJobs.container';

export const TrainingDetailsSubTrainingJobsView = (): ReactElement => <JobSubTrainingJobsContainer />;
